import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import primaryComponents from "../../../../../components/primaryComponents";
import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useNavigate } from "react-router-dom";

const GenerateWaybill = () => {
  const navigate = useNavigate();
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Generate Waybill"
      description="View the details of a Generate Waybill"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className={globalStyles.pageColumnGaps}
          >
            <div
              className="d-flex flex-wrap align-items-center"
              style={{ gap: "10px" }}
            >
              <primaryComponents.Button
                classNames="btn btn--outline"
                onClick={() => navigate(-1)}
              >
                <FontAwesomeIcon
                  icon="angle-left"
                  className="mr-3"
                  style={{ fontSize: "18px" }}
                />
                <span>Back</span>
              </primaryComponents.Button>

              <h4 className="ml-3">Generate Waybill</h4>
            </div>
            <secondaryComponents.WayBillFormV2 />
          </motion.div>
        </>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default GenerateWaybill;
